import React from "react";
import "./Privacy.css"
import { Link } from "react-router-dom";


function Privacy(){
    return(
        <div>
<nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
    <img src="/logo.png" alt="logo" />
    <h5 className="mb-0">
      <span>SVT</span><br />
      DIGITAL INFO TECH
    </h5>

    {/* Toggler Button */}
    <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

    {/* Collapse menu */}
        <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
       <Link className="nav-link" to="/">
  <i className="fa-solid fa-house"></i> HOME
</Link>
        </li>

        <li className="nav-item dropdown">
        <Link
  className="nav-link dropdown-toggle"
  to="#"
  id="navbarDropdownMenuLink"
  role="button"
  data-bs-toggle="dropdown"
  aria-expanded="false"
>
  <i className="fa-solid fa-desktop"></i> SERVICES
</Link>

          <ul
            className="dropdown-menu p-3 custom-dropdown"
            aria-labelledby="navbarDropdownMenuLink"
            style={{ minWidth: '600px' }}
          >
            <div className="row">
              <div className="col-6">
<li>
  <Link className="dropdown-item" to="/website">
    <i className="fa-solid fa-desktop"></i> Website
  </Link>
</li>               <li>
  <Link className="dropdown-item" to="/graphicwork">
    <i className="fa-solid fa-fire"></i> Graphic Work
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/ecommerce">
    <i className="fa-solid fa-cart-shopping"></i> Ecommerce Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/software">
    <i className="fa-solid fa-tv"></i> Software Development
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/business">
    <i className="fa-solid fa-chart-line"></i> Business Consulting
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/erp">
    <i className="fa-solid fa-computer"></i> ERP Software
  </Link>
</li>
              </div>
              <div className="col-6">
               <li>
  <Link className="dropdown-item" to="/search">
    <i className="fa-solid fa-rocket"></i> Search Engine Optimization
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/digitalmarketing">
    <i className="fa-solid fa-satellite-dish"></i> Digital Marketing
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/socialmedia">
    <i className="fa-brands fa-hubspot"></i> Social Media Management
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/lead">
    <i className="fa-solid fa-network-wired"></i> Lead Generation
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/businessbrand">
    <i className="fa-solid fa-tag"></i> Business Branding
  </Link>
</li>
<li>
  <Link className="dropdown-item" to="/hr">
    <i className="fa-brands fa-searchengin"></i> HR Services
  </Link>
</li>
              </div>
            </div>
          </ul>
        </li>

        <li className="nav-item">
        <Link className="nav-link" to="/about">
  <i className="fa-solid fa-circle-info"></i> ABOUT US
</Link>
        </li>

        <li className="nav-item">
      <Link className="nav-link" to="/form">
  <i className="fa-solid fa-address-book"></i> CONTACT
</Link>
        </li>

      </ul>
    </div>
  </div>
</nav>

            <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
 
  <div class="carousel-inner">
    <div class="carousel-item active" data-bs-interval="10000">
      <img src="/privac.png" class="d-block w-100 custom-img" alt="..."/>
      <div class="carousel-caption d-none d-md-block">
      </div>
    </div>
  </div>
</div>
<div className="cont">
    <h1>Privacy Policy for SVT Digital Info Tech</h1>
    <ul className="lists">
        <li>Effective Date: 1-Apr-2025</li>
        <li>Location: Tirupur, Tamil Nadu, India</li>
    </ul>

    <h5>SVT Digital Info Tech (“we”, “our”, or “us”) is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our website or enroll in our services.</h5><br/>
    <h5>By using our services, you agree to the collection and use of information in accordance with this policy.</h5>

<h4>1. Information We Collect</h4>
<h5>We may collect the following types of information:</h5>
<ul>
  <li>Personal Information: Name, email address, phone number, postal address, educationalbackground, and payment details.</li>
  <li>Non-Personal Information: Browser type, IP address, referring website, pages visited, time spent, etc.</li>
  <li>Enrollment Data: Course selection, attendance, assessment results, and feedback.</li>
</ul>

<h4>2. How We Use Your Information</h4>
<h5>We use your information to:</h5>
<ul>
  <li>Process course registration and payment</li>
  <li>Communicate with you about courses, updates, and services</li>
  <li>Improve our website and learning platforms</li>
  <li>Maintain internal records for complianceImprove our website and learning platforms</li>
  <li>Send promotional or informational content with your consent</li>
</ul>



<h4>3. Data Sharing and Disclosure</h4>
<h5>We do not sell or rent your personal data. We may share your data only with:</h5>
<ul>
  <li>Trusted partners or trainers for course delivery</li>
  <li>Government authorities when legally required</li>
  <li>Payment gateways or third-party service providers (with confidentiality agreements)</li>
</ul>


<h4>4. Security Measures</h4>
<h5>We follow reasonable security practices as per the IT Act, 2000, and associated Rules (2011), including:
</h5>
<ul>
  <li>Encrypted storage of sensitive information</li>
  <li>Access control and secure data handling</li>
  <li>Regular system audits</li>
</ul>

<h4>5. Cookies & Tracking</h4>
<h5>Our website may use cookies to enhance your browsing experience. You can choose to disable cookies in your browser settings
</h5>


<h4>6. User Rights</h4>
<h5>As per Indian law, you have the right to:
</h5>
<ul>
  <li>Access, correct, or delete your personal data</li>
  <li>Withdraw consent anytime by contacting us</li>
  <li>File a complaint with the designated Grievance Officer</li>
</ul>

<h4>7. Policy Updates</h4>
<h5>This policy may be updated from time to time. The latest version will always be available on our website.
</h5>



<h4>8. Contact Us</h4>
<h5>If you have any questions regarding this policy, please contact:
</h5>
<ul>
  <li> 📧 Email: svtdigiinfo@gmail.com</li>
  <li>
 📞 Phone: +91-9916828514</li>
</ul>
</div>



<footer class="bg-dark text-white pt-4 pb-2 mt-5">
<div style={{ position: '', width: '100%', height: 'auto', overflow: 'hidden' }}>
      {/* Particle Background */}
      
<div className="icons"> 
  <h3>FOLLOW US IN SOCIALS</h3><br/>

  <a href="https://wa.me/919876543210" target="_blank"><i class="fa-brands fa-whatsapp"></i></a>
<a href="https://instagram.com/svtdigital" target="_blank"> <i class="fa-brands fa-facebook"></i></a>
<a href="https://facebook.com/svtdigital" target="_blank"> <i class="fa-brands fa-instagram"></i></a>
<a href="https://youtube.com/@svtdigital" target="_blank"> <i class="fa-brands fa-youtube"></i></a>

</div>

  <div class="container text-center text-md-left">
    <div class="row">

     

<div class="col-md-4 mb-3 d-flex flex-column align-items-center">
  <h3 class="text-center">QUICK LINKS</h3>
  <ul class="quick-links list-unstyled text-center p-0 m-0">
    <li><a href="/" class="text-white text-decoration-none d-block mb-1">Website Designing </a></li>
    <li><a href="/courses" class="text-white text-decoration-none d-block mb-1">Graphic Work</a></li>
    <li><a href="/contact" class="text-white text-decoration-none d-block mb-1">E-Commerce Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Software Development</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Consulting</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">ERP Software</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Search Engine Optimization</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Digital Marketing</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Social Media Management</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Lead Generation</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">Business Branding</a></li>
    <li><a href="/enquiry" class="text-white text-decoration-none d-block">HR Services</a></li>
  </ul>
</div>

 <div class="col-md-4 mb-3">
  
        <h3>GET DIRECTION</h3>
        <img src="/map.png" alt="" class="map-img"/>
      </div>

<div class="col-md-4 mb-3">
  <h3 class="text-center">CONTACT US</h3>
  <p class="contact-info text-start">
    📍 Kongu Main Rd, near Bharat Petrol Bunk, KN Palayam, V R P Nagar, MS Nagar, Tiruppur, Tamil Nadu 641607<br/>
    📞 99168 28514<br/>
    📧 svtdigital@gmail.com
  </p>
</div>

    </div>

    <hr class="custom-hr" />


    <div class="text-center mt-3">
      <h5>&copy; 2025 SVT Digital Info Tech. All rights reserved.</h5>
    </div>

  </div>
  </div>

</footer>

</div>
    )
}
export default Privacy;